import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import React__default, { useRef, useState } from 'react';
import classNames from 'classnames';
import styles from './71885248123504f5bea8ed8584f83a9cc254b46d8488d99bf30c994f973b0db0.cfe-internal.js';
import { TabContextProvider } from './b5923eed8d526568eb25cb083b9dff7921112e60363bcc0bcbf3cdeecbf709f9.cfe-internal.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import '../../hooks/8930fff059088aae845742b95b03a9c78f1349f3c58d1781f854d37c28181edd.cfe-internal.js';
import useId from '../../hooks/useId/df6d0ff48c086d34ec4e3589a05e8dd99a305947cee007fa9f94a6dd07ae8d17.cfe-internal.js';
import wrapAround from '../../utils/wrapAround/1a639820434d46ac938b209a801f056dade6a52c7e66f2f20149353cdbcba005.cfe-internal.js';
import mergeRefs from '../../utils/mergeRefs/836dcb860bec00d9c59bd64df8df6df42430840bc5bfc21b6000935baefbeacd.cfe-internal.js';

var _excluded = ["activeKey", "children", "className", "onChange", "id"];
var Tabs = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var activeKey = _ref.activeKey,
    children = _ref.children,
    className = _ref.className,
    onChange = _ref.onChange,
    externalId = _ref.id,
    rest = _objectWithoutProperties(_ref, _excluded);
  var tabsId = useId(externalId);
  var tabIdPrefix = "".concat(tabsId, "-tab-");
  var tabPanelIdPrefix = "".concat(tabsId, "-tab-panel-");
  var tabRefs = useRef({});
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    tabIndexOfActiveTab = _useState2[0],
    setTabIndexOfActiveTab = _useState2[1];
  var focusOnIndex = function focusOnIndex(index) {
    var tabRefsLength = _Object$keys(tabRefs.current).length;
    var wrappedIndex = wrapAround(index, 0, tabRefsLength - 1);
    tabRefs.current[wrappedIndex].focus();
  };
  var handleTablistFocus = function handleTablistFocus() {
    setTabIndexOfActiveTab(-1);
  };
  var handleTablistBlur = function handleTablistBlur() {
    setTabIndexOfActiveTab(0);
  };
  var handleSelect = function handleSelect(key) {
    onChange === null || onChange === void 0 || onChange(key);
  };
  var handleKeyDown = function handleKeyDown(event, tabElementKey, index) {
    if (event.key === 'Enter' || event.key === ' ') {
      handleSelect(tabElementKey);
    } else if (event.key === 'ArrowRight') {
      focusOnIndex(index + 1);
    } else if (event.key === 'ArrowLeft') {
      focusOnIndex(index - 1);
    } else if (event.key === 'Home') {
      event.preventDefault();
      tabRefs.current[0].focus();
    } else if (event.key === 'End') {
      event.preventDefault();
      tabRefs.current[_Object$keys(tabRefs.current).length - 1].focus();
    }
  };
  // Chose not to use `React.Children.toArray(..)` because it prefixes the keys (see https://reactjs.org/docs/react-api.html#reactchildrentoarray)
  function getTabs() {
    var _context;
    var tabs = [];
    _forEachInstanceProperty(_context = React__default.Children).call(_context, children, function (child, index) {
      if (child) {
        var _child$props$id;
        var _key = child.key || String(index);
        var active = _key === activeKey;
        var context = {
          active: active,
          tabIndex: active ? tabIndexOfActiveTab : -1
        };
        tabs.push( /*#__PURE__*/React__default.createElement(TabContextProvider, {
          key: _key,
          value: context
        }, /*#__PURE__*/React__default.cloneElement(child, {
          key: _key,
          id: (_child$props$id = child.props.id) !== null && _child$props$id !== void 0 ? _child$props$id : tabIdPrefix + _key,
          children: child.props.children,
          ref: mergeRefs(child.ref, function (node) {
            tabRefs.current[index] = node;
          }),
          onKeyDown: function onKeyDown(event) {
            var _child$props$onKeyDow, _child$props;
            (_child$props$onKeyDow = (_child$props = child.props).onKeyDown) === null || _child$props$onKeyDow === void 0 || _child$props$onKeyDow.call(_child$props);
            handleKeyDown(event, _key, index);
          },
          onClick: function onClick() {
            var _child$props$onClick, _child$props2;
            (_child$props$onClick = (_child$props2 = child.props).onClick) === null || _child$props$onClick === void 0 || _child$props$onClick.call(_child$props2);
            handleSelect(_key);
          },
          'aria-controls': tabPanelIdPrefix + _key
        })));
      }
    });
    return tabs;
  }
  function getPanels() {
    var _context2;
    var panels = [];
    _forEachInstanceProperty(_context2 = React__default.Children).call(_context2, children, function (child, index) {
      if (child) {
        var _child$props$id2;
        var _key2 = child.key || String(index);
        var isActive = _key2 === activeKey;
        var panelClasses = classNames(styles.panel, _defineProperty({}, styles.inactive, !isActive));
        panels.push( /*#__PURE__*/React__default.createElement("div", {
          key: _key2,
          role: "tabpanel",
          "aria-labelledby": (_child$props$id2 = child.props.id) !== null && _child$props$id2 !== void 0 ? _child$props$id2 : tabIdPrefix + _key2,
          className: panelClasses,
          id: tabPanelIdPrefix + _key2
        }, isActive ? child.props.children : null));
      }
    });
    return panels;
  }
  return /*#__PURE__*/React__default.createElement("div", _extends({}, rest, {
    ref: ref,
    className: classNames(className, styles.tabs)
  }), /*#__PURE__*/React__default.createElement("div", {
    role: "tablist",
    className: styles.bar,
    onFocus: handleTablistFocus,
    onBlur: handleTablistBlur
  }, getTabs()), getPanels());
});

export { Tabs as default };
